import { Content, Portal } from '@radix-ui/react-dialog'
import React from 'react'

import { ColorScheme } from '~/experiments/color-scheme/ColorScheme'
import { styled } from '~/styled'

import { DrawerContext } from './Drawer.context'
import { DrawerOverlay } from './DrawerOverlay'

export const StyledContent = styled(Content, {
  base: [
    'bg-(--base-1)',
    'shadow-lg',
    'fixed',
    'z-1147483646',
    'motion-safe:data-[state=open]:animate-slide-direction-in',
    'motion-safe:data-[state=closed]:animate-slide-direction-out'
  ],
  variants: {
    position: {
      top: [
        '[--slide-direction-out-y:-100%]',
        'top-0',
        'left-0',
        'w-full',
        'max-h-17/20'
      ],
      right: [
        '[--slide-direction-out-x:100%]',
        'right-0',
        'top-0',
        'h-full',
        'w-(--drawer-content-width,100%)',
        'max-w-full'
      ],
      bottom: [
        '[--slide-direction-out-y:100%]',
        'bottom-0',
        'left-0',
        'w-full',
        'max-h-17/20'
      ],
      left: [
        '[--slide-direction-out-x:-100%]',
        'left-0',
        'top-0',
        'h-full',
        'w-(--drawer-content-width,100%)',
        'max-w-full'
      ]
    },
    size: {
      xs: ['[--drawer-content-width:240px]'],
      sm: ['[--drawer-content-width:256px]'],
      md: ['[--drawer-content-width:288px]'],
      lg: ['[--drawer-content-width:304px]'],
      xl: ['[--drawer-content-width:320px]'],
      '2xl': ['[--drawer-content-width:720px]'],
      '3xl': ['[--drawer-content-width:1000px]']
    }
  }
})

export const DrawerContent = ({
  children,
  ...rest
}: React.ComponentProps<typeof StyledContent>) => {
  const { position } = React.useContext(DrawerContext)

  return (
    <Portal>
      <DrawerOverlay />
      <ColorScheme base="grey1" accent="primary1" asChild>
        <StyledContent size="lg" position={position} {...rest} asChild>
          <div className="flex flex-col">{children}</div>
        </StyledContent>
      </ColorScheme>
    </Portal>
  )
}
